module.exports = __webpack_public_path__ + "media/images/icons/icons_large/43_decorationFlags-e7657e9b60a691ae69cbe3e95e6cf3ae.png";